import { jwtDecode, JwtPayload } from 'jwt-decode';

// Custom JWT payload type that extends the standard JwtPayload with custom Azure B2C claims
export interface CustomJwtPayload extends JwtPayload {
  extension_id?: string;
  extension_last_signin?: string;
  extension_first_name?: string;
  extension_first_last_name?: string;
  extension_second_last_name?: string;
  extension_external_id?: string;
  tfp?: string;
  extension_roles?: string;
  impersonationApp?: string;
}

const useDecode = (tokenName: string): CustomJwtPayload | undefined => {
  const token = localStorage.getItem(tokenName);
  if (token !== null) {
      const decoded = jwtDecode<CustomJwtPayload>(token);
      return decoded;
  }
  return undefined;
}

export default useDecode;